
import {
    Image,
    TouchableOpacity
} from "react-native";
import {
    type CompanyCardProps
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme
} from "ncore-ui-kit";

const CompanyCard = ({
    companyLogo,
    onPress
}: CompanyCardProps) => {
    const {
        spaces,
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext();

    return <TouchableOpacity
        onPress={onPress}
        activeOpacity={0.8}
        style={[
            stylesheet.container,
            {
                marginRight: spaces.spacingMd,
                borderRadius: radiuses.form || 12,
                borderWidth: borders.line,
                borderColor: colors.content.border.subtle,
                padding: spaces.spacingSm
            }
        ]}
    >
        <Image
            source={{
                uri: companyLogo
            }}
            style={stylesheet.image}
        />
    </TouchableOpacity>;
};
export default CompanyCard;
